import { LoadingContext } from "@/context/LoadingContext";
import type { ILoadingContext } from "@/types/context/LoadingContext";
import { useContext } from "react";

const useLoader = () => useContext<Partial<ILoadingContext>>(LoadingContext);

export default useLoader;
